import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { AnnouncementService } from '@insolution/announcement-data-access';
import { AnnouncementsList } from '@insolution/announcement-ui';
import { Announcement } from '@insolution/graphql-data-access';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'lib-announcements-overview-page',
  imports: [AnnouncementsList, TranslatePipe],
  templateUrl: './announcements-overview-page.html',
  styleUrl: './announcements-overview-page.scss',
})
export class AnnouncementsOverviewPage {
  private announcementService = inject(AnnouncementService);
  private router = inject(Router);

  protected announcements = toSignal(this.announcementService.watchAnnouncements$(), { initialValue: [] });

  protected onCreate(): void {
    this.router.navigate(['/announcements', 'new']);
  }

  protected onEdit(announcement: Announcement): void {
    this.router.navigate(['/announcements', 'edit', announcement.id]);
  }

  protected async onDelete(announcement: Announcement): Promise<void> {
    await this.announcementService.deleteAnnouncement(announcement.id);
  }
}
